import '../styles/iymcs_mark.css';

// capitalize: true → "Iymcs" (первая буква большая — как в исходном тексте "Iymcs"),
// иначе строчными "iymcs" (как в исходном "IYMCS" или "iymcs").
// Подчёркнуты всегда только последние три буквы ("mcs").
const IymcsMark = ({ capitalize = false }) => (
  <span className="iymcs-wordmark">{capitalize ? 'Iy' : 'iy'}<span className="iymcs-mcs">mcs</span></span>
);

// Как было написано в исходном тексте определяет регистр результата:
// "IYMCS" / "iymcs" → строчными; "Iymcs" (с большой первой буквы) → с большой первой буквы.
const IYMCS_WORD = /\b[Ii][Yy][Mm][Cc][Ss]\b/g;
const isCapitalized = (word) => /^[A-Z][a-z]+$/.test(word);

// Для обычного (не HTML) текста — заголовков, вопросов FAQ и т.п.,
// где строка выводится напрямую в JSX ({text}), а не через dangerouslySetInnerHTML.
// Разбивает строку по слову IYMCS/iymcs/Iymcs и подставляет вместо него фирменный знак.
export function withIymcsMark(text) {
  if (!text || typeof text !== 'string' || !IYMCS_WORD.test(text)) return text;
  IYMCS_WORD.lastIndex = 0;
  const result = [];
  let lastIndex = 0;
  let match;
  let key = 0;
  while ((match = IYMCS_WORD.exec(text))) {
    if (match.index > lastIndex) result.push(text.slice(lastIndex, match.index));
    result.push(<IymcsMark key={key++} capitalize={isCapitalized(match[0])} />);
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) result.push(text.slice(lastIndex));
  return result;
}

export default IymcsMark;
